//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { OverlayButton } from '@components/atoms/button/Button';
import { MediaAtomPositionMixins } from '@components/atoms/media/MediaAtomPositionMixins';
import { ITrackableComponent, withTracking } from '@utils/withTracking';

interface Props
  extends React.HTMLAttributes<HTMLDivElement>,
    ITrackableComponent {
  buttonText: string;
  children?: React.ReactNode;
  onClick: (event: React.MouseEvent) => void;
}

/**
 * The PrimaryActionOverlay atom is a simple button on top of
 * a semi-transparent black background. This atom can be strected
 * across the Media atom and be used as a CTA for actions that
 * must be taken on the image.
 */
const PrimaryActionOverlay = ({
  buttonText,
  children,
  className,
  onClick,
  trackingId,
}: Props) => {
  return (
    <PrimaryActionOverlayContainer className={className}>
      <OverlayButton onClick={onClick} trackingId={trackingId}>
        {buttonText}
      </OverlayButton>
      {children}
    </PrimaryActionOverlayContainer>
  );
};

const PrimaryActionOverlayContainer = withTracking(
  styled.div(
    ({ theme }) => `
  ${MediaAtomPositionMixins.Cover};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2]};
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: ${theme.colors.white};
`,
  ),
);

export default PrimaryActionOverlay;
